<div *ngIf="scores">
  <ng-container *ngFor="let onelevel of scores.results">
    <table>
      <tr>
        <td style="padding-right: 10px;"><img [routerLink]="['/avatarbig',playerId]" [src]="avatar || '/assets/avatar.png'" height="70" width="70"
            style="border-radius: 50%; border: 3px solid black;" /></td>
        <td>
          <ng-container *ngIf="scores.results.length == 1">
            <span *ngIf="onelevel.totalPoints == 1">{{scores.fullName}} has 1 point.</span>
            <span *ngIf="onelevel.totalPoints !== 1">{{scores.fullName}} has {{onelevel.totalPoints}} points.</span>
          </ng-container>
          <ng-container *ngIf="scores.results.length > 1">
            <span *ngIf="onelevel.totalPoints == 1">{{scores.fullName}} has 1 point for level {{onelevel.levelNameLong}}.</span>
            <span *ngIf="onelevel.totalPoints !== 1">{{scores.fullName}} has {{onelevel.totalPoints}} points for level
              {{onelevel.levelNameLong}}.</span>
          </ng-container>
        </td>
      </tr>
    </table>
    <br /><br />
    <div *ngIf="onelevel.scores.length == 0">No matches recorded yet.</div>
    <table *ngIf="onelevel.scores.length > 0" class="table table-bordered">
      <thead>
        <tr>
          <th>Round</th>
          <th>Opponent</th>
          <th>Score</th>
          <th class="hide-small">Points</th>
          <th class="hide-small">Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let s of onelevel.scores">
          <td>{{s.round}}</td>
          <td><a [routerLink]="['/player',s.opponentId]">{{s.opponentFullName}}</a></td>

          <td *ngIf="isTiebreakTourney" [ngClass]="{'win':s.points==10, 'loss':s.points<10}">{{s.score}}</td>
          <td *ngIf="!isTiebreakTourney" [ngClass]="{'win':s.points==3 || s.points==4, 'loss':s.points<3}">{{s.score}}</td>

          <td class="hide-small">{{s.points}}</td>
          <td class="hide-small">{{s.getDate()}}</td>
        </tr>
      </tbody>
      <tfoot class="hide-small">
        <tr>
          <td colspan="3" align="right">TOTAL</td>
          <td>{{onelevel.totalPoints}}</td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </ng-container>
</div>